export const WEATHER = "Weather";
export const WEATHER_LOWERCASE = WEATHER.toLowerCase();

export const CURRENT = "Current";
export const CURRENT_LOWERCASE = CURRENT.toLowerCase();

export const LOCATION_PROMPT = "Type or select address";
export const IMPACT = "Impact";
export const GOOD_WEATHER = "GREAT_CONDITIONS"; // Front-end display name for goldilocks
export const BAD_WEATHER = "POOR_CONDITIONS"; // Front-end display name for aggregate impact
export const BOTH_GOOD_AND_BAD_WEATHER = "ALL_CONDITIONS"; // Front-end display name for goldilocks + aggregate
export const IMPACT_LOWERCASE = IMPACT.toLowerCase();
export const DRIVING_IMPACTS_LABEL = "Weather-Based Driving Impacts";

export const LEVEL = "Level";
export const IMPACT_LEVEL = IMPACT + " " + LEVEL;

export const USER_TIPS = "User Tips";
export const OPEN_ROADS_STOPS = "Toggle visibility of preferred gas stops courtesy of OpenRoads";
export const OPEN_ROADS_EMPTY = "No preferred gas stops are present along your route";
export const OPEN_ROADS_LOADING = "Loading preferred gas stops courtesy of Openroads";
export const TOGGLE_FULLSCREEN_ON = "Enter Fullscreen View";
export const TOGGLE_FULLSCREEN_OFF = "Exit Fullscreen View";
export const CHANGE_TIMELINE_SPEED = "Change the playback speed of the timeline";
export const MAP_ZOOM_OUT = "Zoom Out";
export const MAP_ZOOM_IN = "Zoom In";
export const INSTRUCTION_DETAILS = "Overview";
export const CONTACT_SUPPORT = "Contact technical support";
export const METRICS = "Metrics";
export const REQUEST_DETAILS = "Input";
export const VIEW = "View Route";

export const RV_WEATHER = "RV " + WEATHER;
export const MY_PRODUCTS = `My ${RV_WEATHER} Products`;

export type AllowedImpactLevel = "Great" | "Slight" | "Moderate" | "Challenging" | "Hazardous" | "Treacherous";
export const UNRECOGNIZED = "Unrecognized";
export const GOLDILOCKS = "Great";
export const NONE = "No Impacts";
export const LEVEL_ONE = "Slight";
export const LEVEL_TWO = "Moderate";
export const LEVEL_THREE = "Challenging";
export const LEVEL_FOUR = "Hazardous";
export const LEVEL_FIVE = "Treacherous";

export const PLAY = "Animate";
export const PAUSE = "Pause";

export enum SurfaceEnum
    { // These all must match the backend names, so if changing here, also change the backend surface names
    AGGREGATE = "AGGREGATE", // surface name per the backend
    TEMPERATURE = "TEMPERATURE",
    WIND_SPEED = "WIND_SPEED",
    WIND_GUST = "WIND_GUST",
    VISIBILITY = "VISIBILITY",
    THUNDERSTORM = "THUNDERSTORM",
    SNOW = "SNOW",
    ICE = "ICE",
    RAIN = "RAIN"
}

export const NAME = "Trip Name";
export const NAME_TOOLTIP = "Name of the trip";
export const START_STRING = "Start";
export const END_STRING = "End";
export const OVERNIGHT_STOP = "Overnight Stop";
export const OVERNIGHT_STOP_HEADER = "Recommended Overnight Stop";
export const WAYPOINT_STOP_HEADER = "Requested Overnight Stop ";
export const PIT_STOP_STRING = "Pit Stop";
export const BORDER_CROSSING_STRING = "Border Crossing";
export const BORDER_CROSSING_DESCRIPTION = "We expect a border crossing at";
export const BORDER_CROSSING_DISCLAIMER = "Check border crossing hours of operation and documentation requirements before proceeding.";
export const WEATHER_DELAY_STRING = "Weather Delay";
export const WEATHER_DELAY_DESCRIPTION = "Wait until high-impact weather passes through at";
export const START_DATE = `${START_STRING} Date`;
export const DATE_SELECT_HEADER = "Dates";
export const START_DATE_TOOLTIP = "Trip start date (May be delayed by weather)";
export const DATE_WARNING = "Your trip starts more than 8 days out. Set up your trip now - weather impacts will become available a week prior to your starting date.";
export const STARTING_POINT = `${START_STRING}ing Point`;
export const REQUEST_TYPE = "Request Type";
export const DESTINATION = "Destination";
export const MAX_ACCEPTABLE_IMPACT = "Max Acceptable Impact";
export const MAX_SPEED = "Max Driving Speed";
export const MAX_SPEED_TOOLTIP =
    "Highest acceptable travel speed. SureRoute always follows local posted speed limits";
export const OTHER_MAX_SPEED =
    "Use a max speed lower than the posted speed limit";
export const AVOID_TOLLS =
    "Avoid Tolls";
export const ALLOW_CROSSINGS_CANADA =
    "Allow Routing in Canada";
export const ALLOW_CROSSINGS_US =
    "Allow Routing in the United States";
export const ALLOW_CROSSINGS_MEXICO =
    "Allow Routing in Mexico";
export const DAILY_START_TIME = `Daily ${START_STRING} Time`;
export const DAY_1_START_TIME = `Day 1 ${START_STRING} Time`;
export const DAILY_START_TIME_TOOLTIP = "Earliest time to start driving";
export const DAILY_END_TIME = `Ideal Daily ${END_STRING} Time`;
export const DAILY_END_TIME_TOOLTIP = "Desired time to stop driving";
export const DAILY_FINAL_END_TIME = "Must be off the road by";
export const DAILY_FINAL_END_TIME_TOOLTIP = "Latest acceptable time in the day to stop driving";
export const CLOSE = "close";
export const MAX_WEATHER_IMPACT = "Max Weather Impact";
export const MAX_WETAHER_IMPACT_TOOLTIP =
    "Highest impact level you are prepared to accept while driving";
export const VEHICLE = "Vehicle";
export const LOCATION = "Location";
export const LOCATION_TOOLTIP = "Address, City, or State of the waypoint";
export const LOCATION_INVALID = "Please provide a valid address";
export const EDIT_LENGTH_OF_STAY_TOOLTIP = "Edit length of stay";
export const SPECIFY_EARLY_OR_LATE_START = "Override start time for first waypoint";
export const WEIGHT = "Weight";
export const WEIGHT_TOOLTIP = VEHICLE + " " + WEIGHT;
export const WEIGHT_INPUT_TOOLTIP = "Weight of RV or RV and towing vehicle combined. OPTIONAL -- if omitted weight restrictions are ignored.";

export const HEIGHT = "Height";
export const FEET = "Feet";
export const INCHES = "Inches";
export const HEIGHT_TOOLTIP = VEHICLE + " " + HEIGHT;
export const HEIGHT_INPUT_TOOLTIP = "The RV's height. Used for avoiding bridges/tunnels that are too low. OPTIONAL -- If omitted height restrictions are ignored.";


export const SUPPORT_EMAIL = "support@rvweather.com";
export const CANCEL = "Cancel";
export const SUPPORT_HEADER = "Contact us for support";
export const OPEN_MAILTO = "Open Email";
export const HELP_TEXT =
    "Need help? Contact us by pressing the \"" +
    OPEN_MAILTO +
    "\" button below to open your email client.\nOr if you prefer, copy the text below and email " +
    SUPPORT_EMAIL +
    " for support.\n";

export const NEW_WILMA_DATA_AVAILABLE = "There is new weather data available!";

// Initial testing showed that 30k miles is roughly the limit for the routing lambda.
export const MAX_WAYPOINTS = 26; // 1 start, 1 end, and (MAX_WAYPOINTS - 2) intermediate waypoints

export const WAYPOINT_WARNING = `SureRoute is designed to plan your trip for you!  We support up to ${MAX_WAYPOINTS} waypoints, but we find that it leads to the best solutions and best user experience when users minimize their waypoints to required destinations`;
export const WAYPOINT_DISTANCE_WARNING = "These waypoints will take 11 hours or more to drive through. Please consider adding some intermediate stops to let us more accurately score your trip.";
export const IMPACT_LEVEL_WARNING = "Weather conditions level 4 and above include dangerous driving conditions and are not recommended for travel.";
export const LENGTH_OF_STAY_TOOLTIP =
    "Number of nights to stay at this location";
export const LENGTH_OF_STAY_OVERNIGHT = "Length of Stay (# of nights)";
export const LENGTH_OF_STAY_PITSTOP = "Length of Stay (minutes)";
export const LENGTH_OF_STAY_TOOLTIP_PITSTOP =
    "Number of minutes to stop at this location";

export const ADJACENT_WAYPOINT_ERROR = "Adjacent waypoints cannot be the same";
export const FINAL_END_TIME_ERROR_TEXT = "Must be off the road time cannot be earlier than desired end time or start time";
export const DESIRED_END_TIME_ERROR_TEXT = "Daily start time must be earlier than daily end time";


export const USER_PROFILE_HEADER = "Quick Links";
export const MAP_CONTROLS = "Map Controls";
export const ADMIN_CONTROLS = "Administrator";

export const OPACITY = "Opacity";
export const SURFACE_TOGGLE = "Visible Weather Impact Layers";
export const RESET = "Reset Surface Visibility";
export const TOGGLE_ROUTE_VIEW = "Toggle Route Visibility";
export const TOGGLE_ICON_LEGEND = "Toggle Icon Legend Visibility";
export const VISIBLE_STRING = "Visible";
export const INVISIBLE_STRING = "Invisible";
export const MAP_STYLE = "Map Style";
export const TRIP_LIBRARY = "TRIP LIBRARY";
export const ROUTE_OVERVIEW = "ROUTE DETAILS";

export const GENERATING_ROUTE = "Generating your route";
export const ROUTE_TIME_STRING = "Most routes take 2-3 minutes";

export const CLEAR_MAP = "Close Trip";
export const USER_ID_REASSIGN_TEXT = "Enter new User Id";
export const DELETE_CONFIRMATION_HEADER = "Confirm Deletion";
export const DELETE_CONFIRMATION_TEXT = "Are you sure you want to delete this trip? This action can only be reversed by an administrator.";
export const DELETE_CONFIRMATION_YES = "Confirm";
export const DELETE_CONFIRMATION_NO = "Cancel";
export const DELETE = "Delete";
export const VALID_LOCATION = "Location must resolve to a valid street address";
export const FAILED_TO_LOAD_ERRORS = "Failed to load error list";
export const VERSION = "Version";
export const REVISE_TRIP = "Route me";
export const EDIT_BUTTON_TEXT = "Edit Trip";
export const REVISE_TRIP_CONFIRM_TITLE = "Create a new trip or edit this one?";
export const REVISE_TRIP_CONFIRM_CONTENT = "Would you like to edit this trip, or create a new one and keep the current trip unchanged?";
export const EDIT_THIS_TRIP = "Edit This Trip";
export const CREATE_THIS_TRIP = "Create New Trip";
export const GLACIAL_DATA_STRING = "The forecast data for this route has been archived.";

export const NAVBAR_WILMA_TEXT = "Impacts";
export const NAVBAR_LIBRARY_TEXT = "Trips";
export const NAVBAR_ROUTE_TEXT = "Route";

export const DRIVING_TIME_LABEL = "Driving Time";
export const TOTAL_TIME_LABEL = "Total Time";
export const DISTANCE_LABEL = "Distance";
export const OVERNIGHTS_LABEL = "Overnights";
export const WEATHER_DELAY_LABEL = "Weather Delay Duration";
export const HOURS_UNIT = " hrs";
export const MILES_UNIT = " mi";
export const OVERNIGHT_TEMPERATURES_TITLE = "Overnight Temperatures";
export const NIGHT_LABEL = "Stay";
export const MINIMUM_TEMPERATURE_LABEL = "Minimum Temperature";
export const NA_TEXT = "N/A";
export const DEGREE_F = " °F";

export const PIT_STOP_LENGTH_MESSAGE = "Length of pit stop must not exceed the driving time or overnight stay time";
export const OVERNIGHT_STOP_LENGTH_MESSAGE = "Overnight stops must be between 1 and 60 nights";
export const VALUE_NUMERIC = "Value must be a number";
export const INPUT_NEGATIVE_MESSAGE = "Length of stay cannot be negative";

export const LOCATION_SELECT_MODAL_INSTRUCTIONS = "Click on the map to select a position";


export const UNABLE_TO_GENERATE_ROUTE_TIPS_HEADER = "Based on your input, we suggest running your route again with one of the following modifications:";
export const UNABLE_TO_GENERATE_ROUTE_HEIGHT = "Reduce or remove your specified vehicle height";
export const UNABLE_TO_GENERATE_ROUTE_CITIES = "Move your waypoints to nearby major cities";
export const UNABLE_TO_GENERATE_ROUTE_TOLLS = "Uncheck avoid tolls";
export const GENERIC_ROUTE_ERROR_TEXT = "An Error occurred while processing your route.";
export const YOUR_REQUEST_MESSAGE = "Your request:";


export const BEYOND_FORECAST_POPUP_HEADER = " Beyond 8-Day Forecast";
export const OUTSIDE_FORECAST_POPUP_HEADER = " Outside Forecast";
export const BEYOND_FORECAST_POPUP_TEXT = "Re-run your route in a few days for the most up-to-date weather information";
export const OUTSIDE_FORECAST_POPUP_TEXT = "This part of the route is outside of the forecast area.";


export const AUTO_REFRESH_TOOLTIP = "Automatically refresh when a new forecast is available";
export const AUTO_REFRESH_TEXT = "Auto-Update Forecast";

export const CUSTOM_ROUTE_TEXT = "New Trip";
export const CUSTOM_ROUTE_HOVER = "I want SureRoute to plan my safest route";
export const ADVISORY_ROUTE_TEXT = "Check my Route";
export const ADVISORY_ROUTE_HOVER = "I already know my route—just show weather impacts";
export const MORE_OPTIONS = "Route Details";

export const SET_DAY_ONE_START_TIME = "Day one start time";

export const OPEN_ROADS_START_MESSAGE = "Not an open Roads member yet? Sign up ";
export const OPEN_ROADS_LINK = "here";
export const OPEN_ROADS_END_MESSAGE = "to enjoy discounted fuel prices and free expedited card shipping!";
export const NEW_FORECAST_MESSAGE = "Update Forecast";
export const FORECAST_UPDATE_TEXT = "Update your route with your current departure location, time and date";
export const FORECAST_UPDATE_BUTTON = "Update Route";

export const MULTISTART_SELECT_BUTTON_TEXT = "Take This Route";

export const ADMIN_RANKING_VECTOR = "View Ranking Vector";
export const ADMIN_MULTISTART_VARIATION = "Choose a multistart variation:";

export const DATE_CHIPS_HEADER = "Daily Breakdown";

export const SELECT_SUREROUTE_RESULT = "I'll stick with this route";
export const SEE_MULTISTART_PROMPT = "Find me other options";
export const SEE_SUREROUTE_PROMPT = "Show me options with less weather";

export const HIDE_ROUTE_DETAILS_MULTISTART_CARD = "Hide Route Details";
export const SEE_ROUTE_DETAILS_MULTISTART_CARD = "See Route Details";

export const SAVE = "Save";
export const ADVISORY_TEXT = "Choose this option if you've already planned your route and just want to check for weather impacts along the way.";

export const NO_ALTERNATIVE_ROUTES_TEXT = "We crunched the numbers and your original route is actually the best route";
export const SLOW_CONNECTION_WARNING = "We have detected a slow connection, so the playback speed of the forecast has been reduced.";

export const OVERNIGHT_TEMPS_ERROR = "There was an error computing the overnight temperatures.";
export const OVERNIGHT_TEMPS_LOADING = "We're calculating overnight temperatures along your route";

export const WATCHES_WARNINGS_ADVISORIES = "NATIONAL_WEATHER_SERVICE_ALERTS"; //this text is never shown to the user. See the displayName function
export const WATCHES_WARNINGS_ADVISORIES_DISCLAIMER = "Alerts are provided for informational purposes. SureRoute does not include these dynamic alerts in routing recommendations.";

export const COLORED_ROUTE = "COLOR_MY_ROUTE"; //this text is never shown to the user. See the displayName function

export const URGENCY = "Urgency";
export const SEVERITY = "Severity";
export const CERTAINTY = "Certainty";
export const ERROR_FETCHING_TRIPS = "Unable to fetch trips. Please check your network connection and try again.";

export const ACTIVE_STATUS = "Active";
export const ARCHIVED_STATUS = "Archived";
export const CLOSE_DRAWER = "Close drawer";
export const ARCHIVE_TRIP = "Archive";
export const UNARCHIVE_TRIP = "Unarchive";
export const REASSIGN_TRIP = "Reassign";
export const RESTORE_TRIP = "Restore";
export const DELETE_TRIP = "Delete";
export const HISTORICAL_FORECASTS = "Historical Forecasts";
export const ADD_HISTORICAL = "Add " + HISTORICAL_FORECASTS;
export const MAX_HISTORICAL_FORECASTS = 15;
export const HISTORICAL_RULES = `
Once you hit submit, it takes ~30 minutes to compute. 
There is a limit of ${MAX_HISTORICAL_FORECASTS} historical forecasts (to not exceed lambda limits). 
If you need to recalculate a date, then delete it first if it already exists.
There is a MAXIMUM of one request at a time - so submit one and wait ~30 minutes for that one to complete - this is a mongo limitation.
NOAA only has data on AWS back to 2020-05-18, so requests prior to that will fail as there is no data.
Historical data requests must be at least 8 days old - otherwise, they will be marked for automatic deletion by our data management rules.
`;
export const ADD_NEW_HISTORICAL = "Add New Forecast";
export const REFETCH_FORECAST = "Refetch Forecasts";
export const EXISTING_FORECAST = "Existing Forecasts";
export const HISTORICAL_ERROR = "Error fetching the list of historical forecasts";

export const WIND_STREAMLINES_TOGGLE_ON = "Show wind direction along your route";
export const WIND_STREAMLINES_TOGGLE_OFF = "Hide wind direction along your route";
